class BESSAppProjectEvaluationMonitorService extends BESSAppBase {

    static MONITOR_UNTIL_MS = 5 * 1000;
    static MONITOR_PERIOD_MS = 1500;

    constructor() {
        super()
        this.monitoring = true;
        this.hasBeenInProgress = false;
        this.keepMonitoringUntil = null;
        this.progressAmount = $('.app-eval-progress .amount');
        this.progressDesc = $('.app-eval-progress .what');

        this.subscribeToEvents(BESSAppProjectEditorSavedEvent.name, this.#onStartMonitoring);
        this.subscribeToEvents(BESSAppProjectCreditUpdatedEvent.name, this.#onStartMonitoring);
    }

    start() {
        setTimeout(this.#monitor.bind(this), 500);
    }

    #onStartMonitoring() {
        if (!this.monitoring) {
            this.log("Monitoring on");
            this.monitoring = true;
            this.progressAmount.attr('style', 'width:0%;');
            this.progressDesc.text('Evaluating - 0%');
            this.lastProgressPerc = 0;
            this.#doMonitor();
        } else {
            this.log("Extended monitoring on");
            this.keepMonitoringUntil = new Date().getTime() + BESSAppProjectEvaluationMonitorService.MONITOR_UNTIL_MS;
        }
    }

    #monitor() {
        if (this.monitoring) {
            this.#doMonitor();
        }
        setTimeout(this.#monitor.bind(this), BESSAppProjectEvaluationMonitorService.MONITOR_PERIOD_MS);
    }

    #doMonitor() {
        this.log("(check) Evaluating...");
        BESSApp.instance.services.api.project.apiMonitorEvaluating(this.#onMonitorResults.bind(this));
    }

    #onMonitorResults(results) {
        let inProgress = results['in_progress'];
        if (inProgress) {
            this.log("Evaluating...");
            let progress = results['progress'];
            this.progressAmount.animate({'width': '' + progress + '%'}, 500);
            this.progressDesc.text('Running - ' + progress + '%');
            this.hasBeenInProgress = true;
        } else {
            if (this.hasBeenInProgress) {
                this.#getEvaluationResults();
                this.hasBeenInProgress = false;
            }

            if (this.keepMonitoringUntil != null) {
                if (new Date().getTime() > this.keepMonitoringUntil) {
                    this.monitoring = false;
                    this.keepMonitoringUntil = null;
                    this.log("Extended monitoring off");
                }
            } else {
                this.monitoring = false;
                this.log("Monitoring off");
                this.progressDesc.text('Project score');
                this.fireEvent(new BESSAppEvaluatedEvent());
            }
        }
        $('body').addClassIf('app-evaluating', this.monitoring);
    }

    #getEvaluationResults() {
        this.log("Fetching evaluated results");
        BESSApp.instance.services.api.project.apiMonitorEvaluation(this.#handleResults.bind(this));
    }

    #handleResults(evaluatedResults) {
        this.log("Updating from results");
        this.#updateScores(evaluatedResults['scores']);
        this.#updateCredits(evaluatedResults['credits']);
        this.#updateMandatorySummary(evaluatedResults['mandatory_summary']);
        this.#updateSectionTooltip(evaluatedResults['section_tooltip_content']);
        this.#updateDocsEvidence(evaluatedResults['docs'])

        let passFailIndicator = $('.active-section .app-category-pass-fail-indicator');
        let passed = evaluatedResults['section_pass_fail'];
        let changed = (passFailIndicator.hasClass('app-category-has-passed') && !passed) ||
            (passFailIndicator.hasClass('app-category-has-failed') && passed);
        passFailIndicator.addClassIf('app-category-has-passed', passed);
        passFailIndicator.addClassIf('app-category-has-failed', !passed);
        if (!passed) {
            let tooltip = passFailIndicator.find('.app-tooltip');
            if (tooltip.length > 0) {
                let updatedMsg = evaluatedResults['section_failure_message'];
                let popover = bootstrap.Popover.getInstance(tooltip[0]);
                popover._config.content = updatedMsg;
            }
        }

        if (changed) {
            passFailIndicator.highlight();
        }
    }

    #updateScores(scores) {
        this.#updateScore('.app-project-score', scores['project_display']);

        let passed = scores['passed'];
        $('.app-project-pass-fail .app-success-icon').showIf(passed);
        $('.app-project-pass-fail .app-warning-icon').showIf(!passed);
        $('.app-project-progress').addClassIf('app-score-warn', !passed).animate({'width': scores['project'] + '%'});
        this.forEach(scores['sections'], function (sectionScore) {
            let section = sectionScore['identifier'];
            let score = sectionScore['score'];
            let isAnsweredOrCalculated = sectionScore['is_answered_or_calculated'];
            let isPassFail = sectionScore['is_pass_fail'];
            let hasPassed = sectionScore['has_passed'];
            this.#updateScore('.app-section-' + section + '-score', score, isAnsweredOrCalculated ? null : '-');

            let sectionProgress = $('.app-section-' + section + '-progress');
            let sectionIndicator = $('.app-category-pass-fail-indicator-' + section);
            let sectionScoreTooltip = $('.app-category-score-tooltip-' + section);
            if (sectionScoreTooltip.length > 0) {
                let failureMessage = sectionScore['failure_message']
                if (failureMessage == null) {
                    BESSAppTooltip.remove($(sectionScoreTooltip[0]));
                } else {
                    BESSAppTooltip.update($(sectionScoreTooltip[0]), failureMessage);
                }
            }
            sectionProgress.animate({'width': score + '%'});
            if (isPassFail) {
                if (isAnsweredOrCalculated) {
                    if (hasPassed) {
                        sectionProgress.addClass('app-category-has-passed').removeClass('app-category-has-failed');
                        sectionIndicator.addClass('app-category-has-passed').removeClass('app-category-has-failed');
                    } else {
                        sectionProgress.removeClass('app-category-has-passed').addClass('app-category-has-failed');
                        sectionIndicator.removeClass('app-category-has-passed').addClass('app-category-has-failed');
                    }
                } else {
                    sectionProgress.removeClass('app-category-has-passed').removeClass('app-category-has-failed');
                    sectionIndicator.removeClass('app-category-has-passed').removeClass('app-category-has-failed');
                }


            }


        });
    }

    #updateScore(selector, score, zeroValue = null) {
        let formattedScore = '' + score + '%';
        if (zeroValue !== null && score === 0) {
            formattedScore = zeroValue;
        }
        let node = $(selector);
        let existingScore = $.trim(node.text());
        if (existingScore !== formattedScore) {
            node.text(formattedScore);
            node.highlight();
        }
    }

    #updateCredits(creditResults) {
        this.forEach(creditResults, this.#updateCreditResult);
    }

    #updateCreditResult(creditResult) {
        let code = creditResult['code'];
        let score = creditResult['score'];
        let passed = creditResult['passed'];
        let scopedOut = creditResult['scoped_out'];
        let scopedOutLocked = creditResult['scoped_out_locked'];
        let scoreRating = creditResult['score_rating'];
        let profilersHTML = creditResult['profilers'];
        let mandatoryWarn = creditResult['mandatory_warn'];
        let contribution = creditResult['section_contribution'];
        let dependency = creditResult['dependency'];
        let supportingEvidenceRequired = creditResult['supporting_evidence_required'];
        let supportingEvidenceComplete = creditResult['supporting_evidence_complete'];

        BESSApp.instance.managers.credits.credit(code).update(
            score,
            passed,
            mandatoryWarn,
            scopedOut,
            scopedOutLocked,
            scoreRating,
            profilersHTML,
            contribution,
            dependency,
            supportingEvidenceRequired,
            supportingEvidenceComplete,
        );
    }

    #updateMandatorySummary(mandatorySummary) {
        BESSApp.instance.sections.project.components.mandatoryCreditsSummary.update(mandatorySummary);
    }

    #updateSectionTooltip(sectionTooltipContent) {
        let tooltip = $('.active-section .app-category-pass-fail-indicator');
        BESSAppTooltip.update(tooltip, sectionTooltipContent);
    }

    #updateDocsEvidence(docs) {
        BESSApp.instance.sections.project.components.docsEvidence.updateSidebar(docs);
    }
}

class BESSAppEvaluatedEvent extends BESSAppEvent {

    static name = "BESSAppEvaluatedEvent";

    constructor() {
        super(BESSAppEvaluatedEvent.name);
    }
}